import { combineReducers } from 'redux-immutable';
import authReducer from './auth/reducer';

const rootReducer = combineReducers({
  auth: authReducer,
});

export default rootReducer;
